var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2MenShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 38v12a2 2 0 11-4 0V38a1 1 0 00-1-1h-1v33a2 2 0 11-4 0V53.94h-2V70a2 2 0 11-4 0V37h-1a1 1 0 00-1 1v12a2 2 0 11-4 0V38a5 5 0 015-5h12a5 5 0 015 5zm3-35.14c-6.37-.45-13.3 2.7-15.6 9.49A8 8 0 0024.51 20h16a8 8 0 00-5.82-7.65c2.08-4 6.71-5.82 11-5.53 5.22.37 11.31 4 11.31 13.12V72h4V19.94C61 8.86 53.45 3.38 46 2.86zm-11.42 27.2a4 4 0 10-5.16-6.113 4 4 0 005.16 6.113z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Men_shower.5d3f25f8.svg";
export { SvgE2MenShower as ReactComponent };